import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

const sections = gsap.utils.toArray(".section-overlap");

sections.forEach((section) => {
  const prevEl = section.previousElementSibling;
  if (prevEl) {
    ScrollTrigger.create({
      trigger: prevEl,
      start: () =>
        prevEl.offsetHeight < window.innerHeight &&
        !prevEl.classList.contains("section-overlap--last")
          ? "top top"
          : "bottom bottom",
      end: "bottom bottom-=200%",
      pin: !prevEl.closest(".js-modal")
        ? prevEl.querySelector(".section-overlap__inner") ?? true
        : false,
      pinSpacing: false,
    });
  }
});
